import React from "react";
import { Button, InputItem, Toast } from "antd-mobile";
import { createForm } from "rc-form";
import { post } from "../../utils/request";
import styles from "./index.less";
import cookies from "js-cookie";
import md5 from "md5";
import Countdown from "../../components/Countdown";
import { getUrlParam, href } from "../../utils/util";
import api from "./api";
import moment from "moment";
import { getWxUserInfo } from "../../utils/wxLogin";
import wx from "wx";

class Login extends React.Component {
    constructor(props) {
        super(props);
        console.log(1111, props);
        this.state = {
            id: getUrlParam("prePayNumber"),
            isTimeOver: false,
            payInfo: {},
            surplusTime: {
                hour: 23,
                minute: 59,
                second: 59,
            },
            isPaySubmit: false,
            isHadPay: false,
        };
    }
    componentWillMount() {
        if (!cookies.get("openid")) {
            return;
        }
        this.getPrePayInfo();
    }

    getIsHadPay = (data) => {
        let isHadPay = false;
        if (data.status === "7-1") {
            isHadPay = true;
        } else if (data.status === "1") {
            isHadPay = true;
        } else if (
            window.localStorage.getItem("prePayNumber") === data.prePayNumber
        ) {
            isHadPay = true;
        }
        return isHadPay; //;
    };

    getSurplusTime = (time) => {
        const surplusTime =
            3600000 - (moment().valueOf() - moment(time).valueOf());
        let hour = parseInt(surplusTime / 1000 / 60 / 60, 10, 10);
        let minute = parseInt((surplusTime / 1000 / 60) % 60, 10);
        let second = parseInt((surplusTime / 1000) % 60, 10);
        if (hour < 0) {
            hour = 0;
            second = 0;
            second = 0;
        }
        if (minute < 0) {
            minute = 0;
        }
        if (second < 0) {
            second = 0;
        }
        return {
            hour,
            minute,
            second,
        };
    };

    getPrePayInfo = () => {
        const payId = post({
            url: api.prePayInfo,
            data: {
                prePayNumber: this.state.id,
            },
        }).then((res) => {
            if (!(res && res.data && res.data.gmtCreate)) {
                return;
            }
            const surplusTime = this.getSurplusTime(res.data.gmtCreate);
            console.log("============", surplusTime);
            const isHadPay = this.getIsHadPay(res.data);
            this.setState({
                isHadPay: isHadPay,
                surplusTime: surplusTime,
                payInfo: res.data,
            });
        });
    };

    paySubmit = () => {
        if (this.state.isPaySubmit) {
            return;
        }
        this.setState({
            isPaySubmit: true,
        });

        post({
            url: api.payCreate,
            data: {
                prePayNumber: this.state.id,
                agentName: cookies.get("nickname"),
                agentAccountNumber: cookies.get("openid"),
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    let data;
                    try {
                        data = JSON.parse(res.data);
                    } catch (err) {
                        data = res.data;
                    }
                    this.triggerWxPay(data);
                } else {
                    this.setState({
                        isPaySubmit: false,
                    });
                }
            },
            (res) => {
                this.setState({
                    isPaySubmit: false,
                });
            }
        );
    };

    triggerWxPay = (options) => {
        const _this = this;
        window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
                ...options,
            },
            function (res) {
                _this.setState({
                    isPaySubmit: false,
                });
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    window.location.reload();
                    window.localStorage.setItem("prePayNumber", _this.state.id);
                }
            }
        );
    };

    bindTimeOver = () => {
        this.setState({
            isTimeOver: true,
        });
    };

    getCarTypeText = (carType) => {
        let newCarType = carType;
        let startIndex = newCarType.indexOf("（");
        let endIndex = newCarType.indexOf("）");
        let repaceText = "";
        if (startIndex < 0) {
            startIndex = newCarType.indexOf("(");
        }
        if (endIndex < 0) {
            endIndex = newCarType.indexOf(")");
        }
        if (startIndex > 0 && endIndex > 0) {
            repaceText = newCarType.substring(startIndex + 2, endIndex - 2);
            newCarType = newCarType.replace(repaceText, "...");
        }

        return newCarType;
    };

    getBusinessList = (list) => {
        const html = [];
        if (list && list.length) {
            list.map((item) => {
                let billStart = "",
                    billEnd = "";
                if (item.billStartDate) {
                    billStart = item.billStartDate.split(/\s/)[0];
                }
                if (item.billEndDate) {
                    billEnd = item.billEndDate.split(/\s/)[0];
                }
                html.push(
                    <li key={item.billNumber}>
                        <div className={"img"}></div>
                        <div className={"content"}>
                            <p>
                                <b>{item.carPlateNumber}</b>
                                {this.getCarTypeText(item.carType)}
                            </p>
                            <p className={"timeInfo"}>
                                账单周期：{billStart} 至 {billEnd}
                            </p>
                        </div>
                    </li>
                );
            });
        }

        return html;
    };

    render() {
        const { payInfo, surplusTime, isTimeOver, isHadPay } = this.state;

        let timeHtml = (
            <span>
                <span>剩余支付时间&nbsp;</span>
                <Countdown
                    time={surplusTime}
                    triggerTimeOver={this.bindTimeOver}
                ></Countdown>
            </span>
        );
        if (isTimeOver) {
            timeHtml = (
                <span className={"tellInfo"}>
                    此代付订单已经超出代付时间，请尽快支付！
                </span>
            );
        }

        const prePayHtml = [];
        if (!isHadPay && payInfo && payInfo.prePayNumber) {
            prePayHtml.push(
                <div>
                    <div className={"timeBox"}>{timeHtml}</div>
                    <div className={"buttonLayer"}>
                        <Button
                            type="primary"
                            onClick={this.paySubmit}
                            loading={this.state.isPaySubmit}
                            disabled={this.state.isPaySubmit}
                        >
                            豪爽支付
                        </Button>
                    </div>
                    <div className={"textInfo"}>
                        <span>说明：</span>付款前务必和好友再次确认。
                    </div>
                </div>
            );
        }
        console.log(payInfo);
        return (
            <div className={"carRentPayment"}>
                {payInfo.businessList ? (
                    <h3>我有一笔车辆租赁租金需要您代付, 请尽快协助完成代付</h3>
                ) : (
                    <h3>有一笔车辆租赁租金需要您支付，请尽快协助完成付款</h3>
                )}
                <div className={isHadPay ? "box hadPay" : "box prePay"}>
                    <div className={"testA"}>代付金额:</div>
                    <div className={"testB"}>
                        {payInfo.transactionAmount}
                        <span>元</span>
                    </div>
                    <div className={"testC"}>
                        申请人：{payInfo.fromCustomerName}
                    </div>
                    <div></div>
                </div>
                {prePayHtml}
                {payInfo.businessList ? (
                    <div className={"productList"}>
                        <h2>代付订单信息</h2>
                        <ul>{this.getBusinessList(payInfo.businessList)}</ul>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default createForm()(Login);



// WEBPACK FOOTER //
// ./src/pages/carRentPayment/index.js